export const SelectStyles = {
  control: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    borderColor: isSelected || isFocused ? '#5e2064' : '#ced4da',
    boxShadow: isSelected || isFocused ? '0 0 0 1px #5e2064' : '#ced4da',
    '&:hover': {
      borderColor: '#5e2064',
      boxShadow: '0 0 0 1px #5e2064',
    },
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? undefined
      : isSelected
      ? '#5e2064'
      : isFocused
      ? '#5e2064'
      : undefined,
    color: isFocused || isSelected ? 'white' : 'black',
    marginTop: '2px',
    '&:active': {
      backgroundColor: '#5e2064',
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    // top: '14px',
    '&:hover': {
      borderColor: '#5e2064',
    },
    '&:active': {
      borderColor: '#5e2064',
    },
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontSize: '14px',
  }),
};
